module.exports = __webpack_public_path__ + "img/event.9fe08fdc.svg";